import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import api from '../services/api';
import { createUserWithEmailAndPassword, sendEmailVerification } from "firebase/auth";
import { auth } from "../firebase/config";


const SignupPage = () => {
  const [userType, setUserType] = useState('');
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    password: '',
    confirmPassword: '',
    grade: '',
    phone: '',
    trcnNumber: '',
    address: '',
    state: '',
    localGovernment: '',
    subjects: [],
    trcnExamRegistration: {
      fullName: '',
      email: '',
      phone: '',
      qualification: '',
      teachingExperience: '',
      preferredSubjects: [],
      idDocument: null
    }
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState('');
  const [showTRCNExamForm, setShowTRCNExamForm] = useState(false);
  const [hasTRCN, setHasTRCN] = useState(true);

  const navigate = useNavigate();

  const subjectsList = [
    'Mathematics', 'English Language', 'Physics', 'Chemistry', 'Biology',
    'Further Mathematics', 'Economics', 'Accounting', 'Commerce',
    'Government', 'History', 'Geography', 'Literature in English',
    'Computer Science', 'Agricultural Science', 'Technical Drawing'
  ];

  const qualificationsList = [
    'B.Ed', 'B.Sc', 'B.A', 'M.Ed', 'M.Sc', 'M.A', 'PhD',
    'NCE', 'PGDE', 'HND', 'OND', 'SSCE'
  ];

  const nigerianStatesWithLGA = {
    'Abia': ['Aba North', 'Aba South', 'Arochukwu', 'Bende', 'Ikawuno', 'Ikwuano', 'Isiala Ngwa North', 'Isiala Ngwa South', 'Isuikwuato', 'Umu Nneochi', 'Obi Ngwa', 'Ohafia', 'Osisioma Ngwa', 'Ugwunagbo', 'Ukwa East', 'Ukwa West', 'Umuahia North', 'Umuahia South'],
    'Adamawa': ['Demsa', 'Fufore', 'Ganye', 'Girei', 'Gombi', 'Guyuk', 'Hong', 'Jada', 'Lamurde', 'Madagali', 'Maiha', 'Mayo Belwa', 'Michika', 'Mubi North', 'Mubi South', 'Numan', 'Shelleng', 'Song', 'Toungo', 'Yola North', 'Yola South'],
    'Akwa Ibom': ['Abak', 'Eastern Obolo', 'Eket', 'Esit Eket', 'Essien Udim', 'Etim Ekpo', 'Etinan', 'Ibeno', 'Ibesikpo Asutan', 'Ibiono-Ibom', 'Ikot Abasi', 'Ikot Ekpene', 'Ini', 'Itu', 'Mbo', 'Mkpat-Enin', 'Nsit-Atai', 'Nsit-Ibom', 'Nsit-Ubium', 'Obot Akara', 'Okobo', 'Onna', 'Oron', 'Oruk Anam', 'Udung-Uko', 'Ukanafun', 'Uruan', 'Urue-Offong/Oruko', 'Uyo'],
    'Anambra': ['Aguata', 'Anambra East', 'Anambra West', 'Anaocha', 'Awka North', 'Awka South', 'Ayamelum', 'Dunukofia', 'Ekwusigo', 'Idemili North', 'Idemili South', 'Ihiala', 'Njikoka', 'Nnewi North', 'Nnewi South', 'Ogbaru', 'Onitsha North', 'Onitsha South', 'Orumba North', 'Orumba South', 'Oyi'],
    'Bauchi': ['Alkaleri', 'Bauchi', 'Bogoro', 'Damban', 'Darazo', 'Dass', 'Gamawa', 'Ganjuwa', 'Giade', 'Itas/Gadau', "Jama'are", 'Katagum', 'Kirfi', 'Misau', 'Ningi', 'Shira', 'Tafawa Balewa', 'Toro', 'Warji', 'Zaki'],
    'Bayelsa': ['Brass', 'Ekeremor', 'Kolokuma/Opokuma', 'Nembe', 'Ogbia', 'Sagbama', 'Southern Ijaw', 'Yenagoa'],
    'Benue': ['Ado', 'Agatu', 'Apa', 'Buruku', 'Gboko', 'Guma', 'Gwer East', 'Gwer West', 'Katsina-Ala', 'Konshisha', 'Kwande', 'Logo', 'Makurdi', 'Obi', 'Ogbadibo', 'Ohimini', 'Oju', 'Okpokwu', 'Otukpo', 'Tarka', 'Ukum', 'Ushongo', 'Vandeikya'],
    'Borno': ['Abadam', 'Askira/Uba', 'Bama', 'Bayo', 'Biu', 'Chibok', 'Damboa', 'Dikwa', 'Gubio', 'Guzamala', 'Gwoza', 'Hawul', 'Jere', 'Kaga', 'Kala/Balge', 'Konduga', 'Kukawa', 'Kwaya Kusar', 'Mafa', 'Magumeri', 'Maiduguri', 'Marte', 'Mobbar', 'Monguno', 'Ngala', 'Nganzai', 'Shani'],
    'Cross River': ['Abi', 'Akamkpa', 'Akpabuyo', 'Bakassi', 'Bekwarra', 'Biase', 'Boki', 'Calabar Municipal', 'Calabar South', 'Etung', 'Ikom', 'Obanliku', 'Obubra', 'Obudu', 'Odukpani', 'Ogoja', 'Yakuur', 'Yala'],
    'Delta': ['Aniocha North', 'Aniocha South', 'Bomadi', 'Burutu', 'Ethiope East', 'Ethiope West', 'Ika North East', 'Ika South', 'Isoko North', 'Isoko South', 'Ndokwa East', 'Ndokwa West', 'Okpe', 'Oshimili North', 'Oshimili South', 'Patani', 'Sapele', 'Udu', 'Ughelli North', 'Ughelli South', 'Ukwuani', 'Uvwie', 'Warri North', 'Warri South', 'Warri South West'],
    'Ebonyi': ['Abakaliki', 'Afikpo North', 'Afikpo South', 'Ebonyi', 'Ezza North', 'Ezza South', 'Ikwo', 'Ishielu', 'Ivo', 'Izzi', 'Ohaozara', 'Ohaukwu', 'Onicha'],
    'Edo': ['Akoko-Edo', 'Egor', 'Esan Central', 'Esan North-East', 'Esan South-East', 'Esan West', 'Etsako Central', 'Etsako East', 'Etsako West', 'Igueben', 'Ikpoba-Okha', 'Oredo', 'Orhionmwon', 'Ovia North-East', 'Ovia South-West', 'Owan East', 'Owan West', 'Uhunmwonde'],
    'Ekiti': ['Ado Ekiti', 'Efon', 'Ekiti East', 'Ekiti South-West', 'Ekiti West', 'Emure', 'Gbonyin', 'Ido-Osi', 'Ijero', 'Ikere', 'Ikole', 'Ilejemeje', 'Irepodun/Ifelodun', 'Ise/Orun', 'Moba', 'Oye'],
    'Enugu': ['Aninri', 'Awgu', 'Enugu East', 'Enugu North', 'Enugu South', 'Ezeagu', 'Igbo Etiti', 'Igbo Eze North', 'Igbo Eze South', 'Isi Uzo', 'Nkanu East', 'Nkanu West', 'Nsukka', 'Oji River', 'Udenu', 'Udi', 'Uzo Uwani'],
    'FCT Abuja': ['Abaji', 'Bwari', 'Gwagwalada', 'Kuje', 'Kwali', 'Municipal Area Council'],
    'Gombe': ['Akko', 'Balanga', 'Billiri', 'Dukku', 'Funakaye', 'Gombe', 'Kaltungo', 'Kwami', 'Nafada', 'Shongom', 'Yamaltu/Deba'],
    'Imo': ['Aboh Mbaise', 'Ahiazu Mbaise', 'Ehime Mbano', 'Ezinihitte', 'Ideato North', 'Ideato South', 'Ihitte/Uboma', 'Ikeduru', 'Isiala Mbano', 'Isu', 'Mbaitoli', 'Ngor Okpala', 'Njaba', 'Nkwerre', 'Nwangele', 'Obowo', 'Oguta', 'Ohaji/Egbema', 'Okigwe', 'Orlu', 'Orsu', 'Oru East', 'Oru West', 'Owerri Municipal', 'Owerri North', 'Owerri West', 'Unuimo'],
    'Jigawa': ['Auyo', 'Babura', 'Biriniwa', 'Birnin Kudu', 'Buji', 'Dutse', 'Gagarawa', 'Garki', 'Gumel', 'Guri', 'Gwaram', 'Gwiwa', 'Hadejia', 'Jahun', 'Kafin Hausa', 'Kazaure', 'Kiri Kasama', 'Kiyawa', 'Kaugama', 'Maigatari', 'Malam Madori', 'Miga', 'Ringim', 'Roni', 'Sule Tankarkar', 'Taura', 'Yankwashi'],
    'Kaduna': ['Birnin Gwari', 'Chikun', 'Giwa', 'Igabi', 'Ikara', 'Jaba', "Jema'a", 'Kachia', 'Kaduna North', 'Kaduna South', 'Kagarko', 'Kajuru', 'Kaura', 'Kauru', 'Kubau', 'Kudan', 'Lere', 'Makarfi', 'Sabon Gari', 'Sanga', 'Soba', 'Zangon Kataf', 'Zaria'],
    'Kano': ['Ajingi', 'Albasu', 'Bagwai', 'Bebeji', 'Bichi', 'Bunkure', 'Dala', 'Dambatta', 'Dawakin Kudu', 'Dawakin Tofa', 'Doguwa', 'Fagge', 'Gabasawa', 'Garko', 'Garun Mallam', 'Gaya', 'Gezawa', 'Gwale', 'Gwarzo', 'Kabo', 'Kano Municipal', 'Karaye', 'Kibiya', 'Kiru', 'Kumbotso', 'Kunchi', 'Kura', 'Madobi', 'Makoda', 'Minjibir', 'Nasarawa', 'Rano', 'Rimin Gado', 'Rogo', 'Shanono', 'Sumaila', 'Takai', 'Tarauni', 'Tofa', 'Tsanyawa', 'Tudun Wada', 'Ungogo', 'Warawa', 'Wudil'],
    'Katsina': ['Bakori', 'Batagarawa', 'Batsari', 'Baure', 'Bindawa', 'Charanchi', 'Dandume', 'Danja', 'Dan Musa', 'Daura', 'Dutsi', 'Dutsin Ma', 'Faskari', 'Funtua', 'Ingawa', 'Jibia', 'Kafur', 'Kaita', 'Kankara', 'Kankia', 'Katsina', 'Kurfi', 'Kusada', "Mai'Adua", 'Malumfashi', 'Mani', 'Mashi', 'Matazu', 'Musawa', 'Rimi', 'Sabuwa', 'Safana', 'Sandamu', 'Zango'],
    'Kebbi': ['Aleiro', 'Arewa Dandi', 'Argungu', 'Augie', 'Bagudo', 'Birnin Kebbi', 'Bunza', 'Dandi', 'Fakai', 'Gwandu', 'Jega', 'Kalgo', 'Koko/Besse', 'Maiyama', 'Ngaski', 'Sakaba', 'Shanga', 'Suru', 'Wasagu/Danko', 'Yauri', 'Zuru'],
    'Kogi': ['Adavi', 'Ajaokuta', 'Ankpa', 'Bassa', 'Dekina', 'Ibaji', 'Idah', 'Igalamela Odolu', 'Ijumu', 'Kabba/Bunu', 'Kogi', 'Lokoja', 'Mopa Muro', 'Ofu', 'Ogori/Magongo', 'Okehi', 'Okene', 'Olamaboro', 'Omala', 'Yagba East', 'Yagba West'],
    'Kwara': ['Asa', 'Baruten', 'Edu', 'Ekiti', 'Ifelodun', 'Ilorin East', 'Ilorin South', 'Ilorin West', 'Irepodun', 'Isin', 'Kaiama', 'Moro', 'Offa', 'Oke Ero', 'Oyun', 'Pategi'],
    'Lagos': ['Agege', 'Ajeromi-Ifelodun', 'Alimosho', 'Amuwo-Odofin', 'Apapa', 'Badagry', 'Epe', 'Eti-Osa', 'Ibeju-Lekki', 'Ifako-Ijaiye', 'Ikeja', 'Ikorodu', 'Kosofe', 'Lagos Island', 'Lagos Mainland', 'Mushin', 'Ojo', 'Oshodi-Isolo', 'Shomolu', 'Surulere'],
    'Nasarawa': ['Akwanga', 'Awe', 'Doma', 'Karu', 'Keana', 'Keffi', 'Kokona', 'Lafia', 'Nasarawa', 'Nasarawa Egon', 'Obi', 'Toto', 'Wamba'],
    'Niger': ['Agaie', 'Agwara', 'Bida', 'Borgu', 'Bosso', 'Chanchaga', 'Edati', 'Gbako', 'Gurara', 'Katcha', 'Kontagora', 'Lapai', 'Lavun', 'Magama', 'Mariga', 'Mashegu', 'Mokwa', 'Moya', 'Paikoro', 'Rafi', 'Rijau', 'Shiroro', 'Suleja', 'Tafa', 'Wushishi'],
    'Ogun': ['Abeokuta North', 'Abeokuta South', 'Ado-Odo/Ota', 'Egbado North', 'Egbado South', 'Ewekoro', 'Ifo', 'Ijebu East', 'Ijebu North', 'Ijebu North East', 'Ijebu Ode', 'Ikenne', 'Imeko Afon', 'Ipokia', 'Obafemi Owode', 'Odeda', 'Odogbolu', 'Ogun Waterside', 'Remo North', 'Sagamu'],
    'Ondo': ['Akoko North-East', 'Akoko North-West', 'Akoko South-East', 'Akoko South-West', 'Akure North', 'Akure South', 'Ese Odo', 'Idanre', 'Ifedore', 'Ilaje', 'Ile Oluji/Okeigbo', 'Irele', 'Odigbo', 'Okitipupa', 'Ondo East', 'Ondo West', 'Ose', 'Owo'],
    'Osun': ['Aiyedaade', 'Aiyedire', 'Atakunmosa East', 'Atakunmosa West', 'Boluwaduro', 'Boripe', 'Ede North', 'Ede South', 'Egbedore', 'Ejigbo', 'Ife Central', 'Ife East', 'Ife North', 'Ife South', 'Ifedayo', 'Ifelodun', 'Ila', 'Ilesa East', 'Ilesa West', 'Irepodun', 'Irewole', 'Isokan', 'Iwo', 'Obokun', 'Odo Otin', 'Ola Oluwa', 'Olorunda', 'Oriade', 'Orolu', 'Osogbo'],
    'Oyo': ['Afijio', 'Akinyele', 'Atiba', 'Atisbo', 'Egbeda', 'Ibadan North', 'Ibadan North-East', 'Ibadan North-West', 'Ibadan South-East', 'Ibadan South-West', 'Ibarapa Central', 'Ibarapa East', 'Ibarapa North', 'Ido', 'Irepo', 'Iseyin', 'Itesiwaju', 'Iwajowa', 'Kajola', 'Lagelu', 'Ogbomosho North', 'Ogbomosho South', 'Ogo Oluwa', 'Olorunsogo', 'Oluyole', 'Ona Ara', 'Orelope', 'Ori Ire', 'Oyo East', 'Oyo West', 'Saki East', 'Saki West', 'Surulere'],
    'Plateau': ['Barkin Ladi', 'Bassa', 'Bokkos', 'Jos East', 'Jos North', 'Jos South', 'Kanam', 'Kanke', 'Langtang North', 'Langtang South', 'Mangu', 'Mikang', 'Pankshin', "Qua'an Pan", 'Riyom', 'Shendam', 'Wase'],
    'Rivers': ['Abua/Odual', 'Ahoada East', 'Ahoada West', 'Akuku-Toru', 'Andoni', 'Asari-Toru', 'Bonny', 'Degema', 'Eleme', 'Emohua', 'Etche', 'Gokana', 'Ikwerre', 'Khana', 'Obio/Akpor', 'Ogba/Egbema/Ndoni', 'Ogu/Bolo', 'Okrika', 'Omuma', 'Opobo/Nkoro', 'Oyigbo', 'Port Harcourt', 'Tai'],
    'Sokoto': ['Binji', 'Bodinga', 'Dange Shuni', 'Gada', 'Goronyo', 'Gudu', 'Gwadabawa', 'Illela', 'Isa', 'Kebbe', 'Kware', 'Rabah', 'Sabon Birni', 'Shagari', 'Silame', 'Sokoto North', 'Sokoto South', 'Tambuwal', 'Tangaza', 'Tureta', 'Wamako', 'Wurno', 'Yabo'],
    'Taraba': ['Ardo Kola', 'Bali', 'Donga', 'Gashaka', 'Gassol', 'Ibi', 'Jalingo', 'Karim Lamido', 'Kumi', 'Lau', 'Sardauna', 'Takum', 'Ussa', 'Wukari', 'Yorro', 'Zing'],
    'Yobe': ['Bade', 'Bursari', 'Damaturu', 'Fika', 'Fune', 'Geidam', 'Gujba', 'Gulani', 'Jakusko', 'Karasuwa', 'Machina', 'Nangere', 'Nguru', 'Potiskum', 'Tarmuwa', 'Yunusari', 'Yusufari'],
    'Zamfara': ['Anka', 'Bakura', 'Birnin Magaji/Kiyaw', 'Bukkuyum', 'Bungudu', 'Gummi', 'Gusau', 'Kaura Namoda', 'Maradun', 'Maru', 'Shinkafi', 'Talata Mafara', 'Chafe', 'Zurmi']
  };

  const statesList = Object.keys(nigerianStatesWithLGA).sort();

  const handleUserTypeSelect = (type) => {
    setUserType(type);
    setError('');
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    if (name === 'state') {
      setFormData(prevState => ({
        ...prevState,
        state: value,
        localGovernment: ''
      }));
    } else {
      setFormData(prevState => ({
        ...prevState,
        [name]: value
      }));
    }

    setError('');
  };

  const handleTRCNExamChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      trcnExamRegistration: {
        ...prevState.trcnExamRegistration,
        [name]: value
      }
    }));
  };

  const handleSubjectToggle = (subject) => {
    setFormData(prevState => {
      const subjects = [...prevState.subjects];
      if (subjects.includes(subject)) {
        return { ...prevState, subjects: subjects.filter(s => s !== subject) };
      } else {
        return { ...prevState, subjects: [...subjects, subject] };
      }
    });
  };

  const handleTRCNSubjectToggle = (subject) => {
    setFormData(prevState => {
      const subjects = [...prevState.trcnExamRegistration.preferredSubjects];
      if (subjects.includes(subject)) {
        return {
          ...prevState,
          trcnExamRegistration: {
            ...prevState.trcnExamRegistration,
            preferredSubjects: subjects.filter(s => s !== subject)
          }
        };
      } else {
        return {
          ...prevState,
          trcnExamRegistration: {
            ...prevState.trcnExamRegistration,
            preferredSubjects: [...subjects, subject]
          }
        };
      }
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (userType === 'parent') {
      alert('Parent registration will be available soon. We appreciate your interest in EduLinker.');
      return;
    }

    setIsSubmitting(true);
    setError('');

    // ================= VALIDATION =================

    if (formData.password !== formData.confirmPassword) {
      setError('Passwords do not match!');
      setIsSubmitting(false);
      return;
    }

    if (formData.password.length < 6) {
      setError('Password must be at least 6 characters long!');
      setIsSubmitting(false);
      return;
    }

    if (userType === 'teacher' && formData.subjects.length === 0) {
      setError('Please select at least one subject you specialize in.');
      setIsSubmitting(false);
      return;
    }

    if (userType === 'teacher' && (!formData.state || !formData.localGovernment)) {
      setError('Please select both State and Local Government Area.');
      setIsSubmitting(false);
      return;
    }

    if ((userType === 'student' || userType === 'parent') && !formData.state) {
      setError('Please select your State.');
      setIsSubmitting(false);
      return;
    }

    // Track whether the Firebase account was created, so we know
    // whether to attempt cleanup if a later step fails
    let createdUser = null;

    try {
      let examRegistered = false;

      // ================= TEACHER TRCN LOGIC =================
      if (userType === 'teacher' && !hasTRCN) {
        if (
          !formData.trcnExamRegistration.fullName ||
          !formData.trcnExamRegistration.qualification
        ) {
          setError('Please complete required TRCN exam fields.');
          setIsSubmitting(false);
          return;
        }
        examRegistered = true;
      }

      // ================= PREPARE USER DATA =================
      const userData = {
        firstName: formData.firstName,
        lastName: formData.lastName,
        email: formData.email,
        password: formData.password,
        name: `${formData.firstName} ${formData.lastName}`,
        phone: formData.phone,
        userType,
        address: formData.address || '',
        state: formData.state || '',
        localGovernment: formData.localGovernment || '',

        ...(userType === 'student' && {
          grade: formData.grade
        }),

        ...(userType === 'teacher' && {
          trcnNumber: formData.trcnNumber || null,
          subjects: formData.subjects,
          isVerified: false,
          trcnExamRegistered: examRegistered,
          trcnStatus: hasTRCN ? 'pending_verification' : 'exam_pending'
        }),

        ...(userType === 'parent' && {
          children: []
        })
      };

      // ================= CREATE FIREBASE AUTH USER =================
      const userCredential = await createUserWithEmailAndPassword(
        auth,
        userData.email,
        userData.password
      );

      const user = userCredential.user;
      createdUser = user;

      // Get Firebase ID token
      const token = await user.getIdToken();

      // ================= CREATE BACKEND PROFILE =================
      const profileResponse = await api.post(
        '/users/create-profile',
        {
          uid: user.uid,
          email: user.email,
          userType,
          firstName: userData.firstName,
          lastName: userData.lastName,
          name: userData.name,
          phone: userData.phone || '',
          address: userData.address || '',
          state: userData.state || '',
          localGovernment: userData.localGovernment || '',
          ...(userType === 'student' && { grade: userData.grade }),
          ...(userType === 'teacher' && {
            subjects: userData.subjects,
            trcnNumber: userData.trcnNumber,
            isVerified: false,
            trcnExamRegistered: examRegistered,
            trcnStatus: userData.trcnStatus
          })
        },
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );

      console.log('✅ Profile created successfully:', profileResponse.data);

      // ================= SEND EMAIL VERIFICATION =================
      // ✅ NEW — sends Firebase's verification link to the user's email
      await sendEmailVerification(user, {
        // After clicking the link, Firebase redirects here
        url: 'https://www.edulinker.app/login',
      });

      console.log('✅ Verification email sent to:', user.email);

      // ================= SIGN OUT & REDIRECT =================
      // Sign out immediately — user cannot access the dashboard
      // until they click the verification link in their email
      await auth.signOut();
      localStorage.clear();

      navigate('/login', {
        state: {
          message:
            'Account created! We sent a verification link to your email. Please verify your email before logging in.'
        }
      });

    } catch (error) {
      console.error('Signup error:', error);

      let errorMessage = 'An error occurred. Please try again.';

      if (error.code === 'ECONNABORTED' || error.userMessage) {
        errorMessage = error.userMessage || 'Server is starting up. Please wait 30 seconds and try again ⏳';
      } else if (error.code === 'auth/email-already-in-use') {
        errorMessage = 'This email is already registered. Please login instead.';
      } else if (error.code === 'auth/weak-password') {
        errorMessage = 'Password is too weak. Please use a stronger password.';
      } else if (error.code === 'auth/invalid-email') {
        errorMessage = 'Please enter a valid email address.';
      } else if (error.response) {
        errorMessage = error.response.data?.message || 'Registration failed. Please try again.';
      } else if (error.request) {
        errorMessage = 'Network error. Please check your connection and try again.';
      } else {
        errorMessage = 'Error creating account: ' + error.message;
      }

      // ✅ If the Firebase account was created but a later step failed
      // (profile creation or sending the verification email), make sure
      // we don't leave the user stuck mid-flow — sign them out so they
      // land back on a clean state and can retry from login/signup.
      if (createdUser) {
        try {
          await auth.signOut();
          localStorage.clear();
        } catch (signOutError) {
          console.error('Cleanup sign-out error:', signOutError);
        }
      }

      setError(errorMessage);

    } finally {
      setIsSubmitting(false);
    }
  };

  const renderTeacherTRCNFields = () => {
    if (showTRCNExamForm) {
      return (
        <div className="card border-primary">
          <div className="card-header bg-primary text-white">
            <h6 className="mb-0">TRCN Examination Registration</h6>
          </div>
          <div className="card-body">
            <div className="row mb-3">
              <div className="col-md-6">
                <label htmlFor="trcnFullName" className="form-label">Full Name *</label>
                <input
                  type="text"
                  className="form-control rounded-3"
                  id="trcnFullName"
                  name="fullName"
                  autoComplete="name"
                  value={formData.trcnExamRegistration.fullName}
                  onChange={handleTRCNExamChange}
                  required
                />
              </div>
              <div className="col-md-6">
                <label htmlFor="trcnEmail" className="form-label">Email *</label>
                <input
                  type="email"
                  className="form-control rounded-3"
                  id="trcnEmail"
                  name="email"
                  autoComplete="email"
                  value={formData.trcnExamRegistration.email}
                  onChange={handleTRCNExamChange}
                  required
                />
              </div>
            </div>

            <div className="row mb-3">
              <div className="col-md-6">
                <label htmlFor="trcnPhone" className="form-label">Phone Number *</label>
                <input
                  type="tel"
                  className="form-control rounded-3"
                  id="trcnPhone"
                  name="phone"
                  autoComplete="tel"
                  value={formData.trcnExamRegistration.phone}
                  onChange={handleTRCNExamChange}
                  required
                />
              </div>
              <div className="col-md-6">
                <label htmlFor="trcnQualification" className="form-label">Highest Qualification *</label>
                <select
                  className="form-select"
                  id="trcnQualification"
                  name="qualification"
                  value={formData.trcnExamRegistration.qualification}
                  onChange={handleTRCNExamChange}
                  required
                >
                  <option value="">Select Qualification</option>
                  {qualificationsList.map(qual => (
                    <option key={qual} value={qual}>{qual}</option>
                  ))}
                </select>
              </div>
            </div>

            <div className="mb-3">
              <label htmlFor="trcnExperience" className="form-label">Teaching Experience *</label>
              <textarea
                className="form-control rounded-3"
                id="trcnExperience"
                name="teachingExperience"
                value={formData.trcnExamRegistration.teachingExperience}
                onChange={handleTRCNExamChange}
                placeholder="Describe your teaching experience..."
                rows="3"
                required
              />
            </div>

            <div className="mb-3">
              <label className="form-label">Preferred Teaching Subjects *</label>
              <div className="row">
                {subjectsList.map((subject) => (
                  <div key={subject} className="col-md-4 mb-2">
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id={`trcnSubject-${subject.replace(/\s+/g, '-')}`}
                        checked={formData.trcnExamRegistration.preferredSubjects.includes(subject)}
                        onChange={() => handleTRCNSubjectToggle(subject)}
                      />
                      <label className="form-check-label" htmlFor={`trcnSubject-${subject.replace(/\s+/g, '-')}`}>
                        {subject}
                      </label>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="alert alert-info">
              <small>
                <strong>Note:</strong> After submitting your TRCN exam registration,
                our team will contact you with examination details and schedule.
                You can start teaching on our platform while your TRCN registration is being processed.
              </small>
            </div>
          </div>
        </div>
      );
    }

    return (
      <div className="mb-3">
        <label htmlFor="trcnNumber" className="form-label">TRCN Number *</label>
        <input
          type="text"
          className="form-control rounded-3"
          id="trcnNumber"
          name="trcnNumber"
          autoComplete="off"
          value={formData.trcnNumber}
          onChange={handleInputChange}
          required
          placeholder="Enter your TRCN registration number"
        />
        <div className="form-text">TRCN verification is required for teacher registration</div>
      </div>
    );
  };

  const renderFormFields = () => {
    const commonFields = (
      <>
        <div className="row mb-3">
          <div className="col-md-6">
            <label htmlFor="firstName" className="form-label">First Name *</label>
            <input
              type="text"
              className="form-control rounded-3"
              id="firstName"
              name="firstName"
              autoComplete="given-name"
              value={formData.firstName}
              onChange={handleInputChange}
              required
            />
          </div>
          <div className="col-md-6">
            <label htmlFor="lastName" className="form-label">Last Name *</label>
            <input
              type="text"
              className="form-control rounded-3"
              id="lastName"
              name="lastName"
              autoComplete="family-name"
              value={formData.lastName}
              onChange={handleInputChange}
              required
            />
          </div>
        </div>

        <div className="mb-3">
          <label htmlFor="email" className="form-label">Email *</label>
          <input
            type="email"
            className="form-control rounded-3"
            id="email"
            name="email"
            autoComplete="email"
            value={formData.email}
            onChange={handleInputChange}
            required
          />
        </div>

        <div className="mb-3">
          <label htmlFor="phone" className="form-label">Phone Number *</label>
          <input
            type="tel"
            className="form-control rounded-3"
            id="phone"
            name="phone"
            autoComplete="tel"
            value={formData.phone}
            onChange={handleInputChange}
            required
            placeholder="e.g., 08012345678"
          />
        </div>

        <div className="row mb-3">
          <div className="col-md-6">
            <label htmlFor="password" className="form-label">Password *</label>
            <input
              type="password"
              className="form-control rounded-3"
              id="password"
              name="password"
              autoComplete="new-password"
              value={formData.password}
              onChange={handleInputChange}
              required
              minLength="6"
              placeholder="At least 6 characters"
            />
          </div>
          <div className="col-md-6">
            <label htmlFor="confirmPassword" className="form-label">Confirm Password *</label>
            <input
              type="password"
              className="form-control rounded-3"
              id="confirmPassword"
              name="confirmPassword"
              autoComplete="new-password"
              value={formData.confirmPassword}
              onChange={handleInputChange}
              required
              minLength="6"
            />
          </div>
        </div>
      </>
    );

    const renderLGAField = () => (
      <div className="col-md-6">
        <label htmlFor="localGovernment" className="form-label">Local Government Area (LGA) *</label>
        <select
          className="form-select"
          id="localGovernment"
          name="localGovernment"
          autoComplete="address-level2"
          value={formData.localGovernment}
          onChange={handleInputChange}
          required
          disabled={!formData.state}
        >
          <option value="">
            {formData.state ? 'Select LGA' : 'Select State first'}
          </option>
          {formData.state && nigerianStatesWithLGA[formData.state]?.map((lga) => (
            <option key={lga} value={lga}>{lga}</option>
          ))}
        </select>
        {!formData.state && (
          <div className="form-text">Please select a state first</div>
        )}
      </div>
    );

    switch (userType) {
      case 'student':
        return (
          <>
            {commonFields}
            <div className="mb-3">
              <label htmlFor="grade" className="form-label">Grade/Class *</label>
              <select className="form-select" id="grade" name="grade"
                value={formData.grade} onChange={handleInputChange} required>
                <option value="">Select Grade/Class</option>
                <option value="Primary 1">Primary 1</option>
                <option value="Primary 2">Primary 2</option>
                <option value="Primary 3">Primary 3</option>
                <option value="Primary 4">Primary 4</option>
                <option value="Primary 5">Primary 5</option>
                <option value="Primary 6">Primary 6</option>
                <option value="JSS 1">JSS 1</option>
                <option value="JSS 2">JSS 2</option>
                <option value="JSS 3">JSS 3</option>
                <option value="SSS 1">SSS 1</option>
                <option value="SSS 2">SSS 2</option>
                <option value="SSS 3">SSS 3</option>
              </select>
            </div>
            <div className="mb-3">
              <label htmlFor="address" className="form-label">Address *</label>
              <input
                type="text"
                className="form-control rounded-3"
                id="address"
                name="address"
                autoComplete="street-address"
                value={formData.address}
                onChange={handleInputChange}
                required
                placeholder="Your residential address"
              />
            </div>
            <div className="row mb-3">
              <div className="col-md-6">
                <label htmlFor="state" className="form-label">State *</label>
                <select
                  className="form-select"
                  id="state"
                  name="state"
                  autoComplete="address-level1"
                  value={formData.state}
                  onChange={handleInputChange}
                  required
                >
                  <option value="">Select State</option>
                  {statesList.map(state => (
                    <option key={state} value={state}>{state}</option>
                  ))}
                </select>
              </div>
              {renderLGAField()}
            </div>
          </>
        );

      case 'teacher':
        return (
          <>
            {commonFields}

            <div className="mb-3">
              <label className="form-label">Do you have a TRCN number?</label>
              <div className="row">
                <div className="col-md-6">
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="hasTRCN"
                      id="hasTRCNYes"
                      checked={hasTRCN}
                      onChange={() => {
                        setHasTRCN(true);
                        setShowTRCNExamForm(false);
                      }}
                    />
                    <label className="form-check-label" htmlFor="hasTRCNYes">
                      Yes, I have a TRCN number
                    </label>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="hasTRCN"
                      id="hasTRCNNo"
                      checked={!hasTRCN}
                      onChange={() => {
                        setHasTRCN(false);
                        setShowTRCNExamForm(true);
                      }}
                    />
                    <label className="form-check-label" htmlFor="hasTRCNNo">
                      No, register for TRCN exam
                    </label>
                  </div>
                </div>
              </div>
            </div>

            {renderTeacherTRCNFields()}

            <div className="mb-3">
              <label className="form-label">Subjects You Specialize In *</label>
              <div className="row">
                {subjectsList.map((subject) => (
                  <div key={subject} className="col-md-4 mb-2">
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id={`subject-${subject.replace(/\s+/g, '-')}`}
                        checked={formData.subjects.includes(subject)}
                        onChange={() => handleSubjectToggle(subject)}
                      />
                      <label className="form-check-label" htmlFor={`subject-${subject.replace(/\s+/g, '-')}`}>
                        {subject}
                      </label>
                    </div>
                  </div>
                ))}
              </div>
              {formData.subjects.length === 0 && (
                <div className="form-text text-warning">Please select at least one subject</div>
              )}
            </div>

            <div className="row mb-3">
              <div className="col-md-12 mb-3">
                <label htmlFor="address" className="form-label">Address *</label>
                <input
                  type="text"
                  className="form-control rounded-3"
                  id="address"
                  name="address"
                  autoComplete="street-address"
                  value={formData.address}
                  onChange={handleInputChange}
                  required
                  placeholder="Your full residential address"
                />
              </div>
              <div className="col-md-6">
                <label htmlFor="state" className="form-label">State *</label>
                <select
                  className="form-select"
                  id="state"
                  name="state"
                  autoComplete="address-level1"
                  value={formData.state}
                  onChange={handleInputChange}
                  required
                >
                  <option value="">Select State</option>
                  {statesList.map(state => (
                    <option key={state} value={state}>{state}</option>
                  ))}
                </select>
              </div>
              {renderLGAField()}
            </div>
          </>
        );

      case 'parent':
        return (
          <>
            {commonFields}
            <div className="row mb-3">
              <div className="col-md-12 mb-3">
                <label htmlFor="address" className="form-label">Address *</label>
                <input
                  type="text"
                  className="form-control rounded-3"
                  id="address"
                  name="address"
                  autoComplete="street-address"
                  value={formData.address}
                  onChange={handleInputChange}
                  required
                />
              </div>
              <div className="col-md-6">
                <label htmlFor="state" className="form-label">State *</label>
                <select
                  className="form-select"
                  id="state"
                  name="state"
                  autoComplete="address-level1"
                  value={formData.state}
                  onChange={handleInputChange}
                  required
                >
                  <option value="">Select State</option>
                  {statesList.map(state => (
                    <option key={state} value={state}>{state}</option>
                  ))}
                </select>
              </div>
              {renderLGAField()}
            </div>
          </>
        );

      default:
        return null;
    }
  };

  // User Type Selection Screen
  if (!userType) {
    return (
      <div className="min-vh-100 bg-light d-flex flex-column">
        <nav className="navbar navbar-expand-lg navbar-light bg-white shadow-sm">
          <div className="container">
            <Link className="navbar-brand d-flex align-items-center" to="/">
              <img
                src="/logo.png"
                alt="EduSpace Logo"
                height="40"
                className="me-2"
              />
              <span className="edu-logo-text">EduLinker</span>
            </Link>
            <div className="navbar-nav ms-auto">
              <Link to="/login" className="btn btn-outline-dark rounded-3 px-3">Login</Link>
            </div>
          </div>
        </nav>

        <div className="container py-5 flex-grow-1">
          <div className="row justify-content-center">
            <div className="col-lg-8">

              <div className="text-center mb-5">
                <h1 className="fw-bold text-dark mb-2" style={{ fontSize: "2rem" }}>
                  Join EduLinker
                </h1>
                <p className="text-muted">
                  Choose how you want to use the platform
                </p>
              </div>

              <div className="row g-4">

                <div className="col-md-4">
                  <div
                    className="card h-100 border-0 shadow-sm rounded-4 role-card"
                    onClick={() => handleUserTypeSelect('student')}
                  >
                    <div className="card-body text-center p-4">
                      <div
                        className="mx-auto mb-3 d-flex align-items-center justify-content-center rounded-circle"
                        style={{
                          width: "60px",
                          height: "60px",
                          background: "#eef2ff",
                          color: "#4f46e5",
                          fontSize: "1.5rem"
                        }}
                      >
                        <i className="fas fa-user-graduate"></i>
                      </div>
                      <h6 className="fw-bold mb-2">Student</h6>
                      <small className="text-muted">
                        Get help instantly and improve your learning
                      </small>
                    </div>
                  </div>
                </div>

                <div className="col-md-4">
                  <div
                    className="card h-100 border-0 shadow-sm rounded-4 role-card"
                    onClick={() => handleUserTypeSelect('teacher')}
                  >
                    <div className="card-body text-center p-4">
                      <div
                        className="mx-auto mb-3 d-flex align-items-center justify-content-center rounded-circle"
                        style={{
                          width: "60px",
                          height: "60px",
                          background: "#ecfeff",
                          color: "#0891b2",
                          fontSize: "1.5rem"
                        }}
                      >
                        <i className="fas fa-chalkboard-teacher"></i>
                      </div>
                      <h6 className="fw-bold mb-2">Teacher</h6>
                      <small className="text-muted">
                        Teach students and earn while helping others
                      </small>
                    </div>
                  </div>
                </div>

                <div className="col-md-4">
                  <div
                    className="card h-100 border-0 shadow-sm rounded-4 role-card"
                    onClick={() => handleUserTypeSelect('parent')}
                  >
                    <div className="card-body text-center p-4">
                      <div
                        className="mx-auto mb-3 d-flex align-items-center justify-content-center rounded-circle"
                        style={{
                          width: "60px",
                          height: "60px",
                          background: "#f0fdf4",
                          color: "#16a34a",
                          fontSize: "1.5rem"
                        }}
                      >
                        <i className="fas fa-users"></i>
                      </div>
                      <h6 className="fw-bold mb-2">Parent</h6>
                      <small className="text-muted">
                        Parent registration coming soon
                      </small>
                    </div>
                  </div>
                </div>

              </div>

            </div>
          </div>
        </div>
      </div>
    );
  }

  // Registration Form Screen
  return (
    <div className="min-vh-100 bg-light d-flex flex-column">
      <nav className="navbar bg-white border-bottom">
        <div className="container py-2 d-flex align-items-center justify-content-between">

          <Link
            className="d-flex align-items-center text-decoration-none"
            to="/"
          >
            <img
              src="/logo.png"
              alt="EduLinker Logo"
              height="36"
              className="me-2"
            />
            <span className="fw-semibold text-dark">
              EduLinker
            </span>
          </Link>

          <div className="d-flex align-items-center gap-2">
            <button
              className="btn btn-light border rounded-3 px-3"
              onClick={() => setUserType('')}
              disabled={isSubmitting}
            >
              <i className="fas fa-arrow-left me-1"></i>
              Back
            </button>

            <Link
              to="/login"
              className="btn btn-dark rounded-3 px-3"
            >
              Login
            </Link>
          </div>

        </div>
      </nav>
      <div className="container py-4 flex-grow-1">
        <div className="row justify-content-center">
          <div className="col-lg-8">
            <div
              className="card border-0 shadow-sm rounded-4"
              style={{ overflow: "hidden" }}
            >
              <div
                className="card-header py-4 border-0"
                style={{
                  background: "linear-gradient(135deg, #4f46e5, #6366f1)",
                  borderTopLeftRadius: "1rem",
                  borderTopRightRadius: "1rem"
                }}
              >
                <div className="text-center">
                  <h2 className="h3 mb-1">
                    Sign up as {userType.charAt(0).toUpperCase() + userType.slice(1)}
                  </h2>
                  <p className="mb-0 opacity-75">Create your account and start your journey</p>
                </div>
              </div>
              <div className="card-body p-4 p-md-5" style={{ lineHeight: "1.6" }}>
                {error && (
                  <div className="alert border-0 rounded-3" style={{
                    background: "#fef2f2",
                    color: "#991b1b"
                  }}>
                    {error}
                  </div>
                )}

                <form onSubmit={handleSubmit}>
                  {renderFormFields()}

                  <div className="form-check mt-4">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      id="terms"
                      name="terms"
                      required
                    />
                    <label className="form-check-label" htmlFor="terms">
                      I agree to the <a href="/terms" className="text-decoration-none">Terms of Service</a> and
                      <a href="/privacy" className="text-decoration-none">Privacy Policy</a>
                    </label>
                  </div>

                  <div className="d-grid mt-4">
                    <button
                      type="submit"
                      className="btn btn-dark btn-lg rounded-3 fw-semibold"
                      disabled={isSubmitting}
                    >
                      {isSubmitting ? (
                        <>
                          <span className="spinner-border spinner-border-sm me-2"></span>
                          Creating Account...
                        </>
                      ) : (
                        'Create Account'
                      )}
                    </button>
                  </div>

                  {/* ✅ NEW — lets the user know an email step is coming */}
                  {isSubmitting && (
                    <div className="text-center mt-3">
                      <small className="text-muted">
                        ⏳ This may take a moment — we'll also send a verification link to your email
                      </small>
                    </div>
                  )}
                </form>

                <div className="text-center mt-4">
                  <p className="text-muted">
                    Already have an account? <Link to="/login" className="text-decoration-none">Login here</Link>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignupPage;